import React from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  labelClass?: string
  error?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, labelClass, label, error, leftIcon, rightIcon, ...props }, ref) => {
  return (
    <div className="w-full space-y-1.5">
      {label && (
        <label htmlFor={props.id} className={cn('block text-sm font-medium text-white dark:text-white', labelClass)}>
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-primary/60">{leftIcon}</div>}
        <input
          ref={ref}
          className={cn(
            'w-full rounded-md border border-gray-300 bg-[#f8f9fa] px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-50 dark:placeholder:text-gray-400 dark:focus:border-primary dark:focus:ring-primary',
            leftIcon && 'pl-10',
            rightIcon && 'pr-10',
            error && 'border-red-500 focus:border-red-500 focus:ring-red-500 dark:border-red-500 dark:focus:border-red-500 dark:focus:ring-red-500',
            className
          )}
          {...props}
        />
        {rightIcon && <div className="absolute inset-y-0 right-0 flex items-center pr-3 text-primary/60">{rightIcon}</div>}
      </div>
      {error && <p className="text-sm text-red-500 dark:text-red-400">{error}</p>}
    </div>
  )
})

Input.displayName = 'Input'
